import { RepassesDialogComponent } from '../../shared/components/repasses-dialog/repasses-dialog.component';
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { SessionService } from '../../core/services/session.service';
import { EtapasBeneficioComponent } from '../../shared/components/etapas-beneficio/etapas-beneficio.component';
import { DeducoesService } from '../../core/services/deducoes.service';
import { MatIconModule } from '@angular/material/icon';
import {
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressBarModule } from '@angular/material/progress-bar';

@Component({
  selector: 'app-deducoes',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatButtonModule,
    MatInputModule,
    MatDialogModule,
    MatIconModule,
    MatCardModule,
    MatTableModule,
    MatProgressSpinnerModule,
    MatSnackBarModule,
    MatTooltipModule,
    MatProgressBarModule,
    EtapasBeneficioComponent,
  ],
  templateUrl: './deducoes.component.html',
  styleUrl: './deducoes.component.scss',
})
export class DeducoesComponent implements OnInit {
  beneficiario: any = '';
  deducoes: any[] = [];
  loading = true;

  displayedColumns: string[] = [
    'motivoAfastamento',
    'dscTipoAfastamento',
    'datAfastamento',
    'datRetorno',
    'qtdTotalDias',
    'qtdDiasDeduzidos',
    'statusDoc',
    'acoes',
  ];

  // upload state
  @ViewChild('modalUpload') modalUpload!: TemplateRef<any>;
  selectedFile: File | null = null;
  uploading = false;
  deducaoSelecionada: any = null;
  private dialogRef?: MatDialogRef<any>;

  constructor(
    private dialog: MatDialog,
    private deducoesService: DeducoesService,
    private sessionService: SessionService,
    private snackBar: MatSnackBar
  ) {}

  editarRepasses(registro:any): void {
    this.dialog.open(RepassesDialogComponent,{width:'950px',maxWidth:'98vw',data:{justificativa:registro.justificativa,tipo:'deducao',id:registro.id,matricula:this.beneficiario.matricula,idOrgao:this.beneficiario.orgao.id}}).afterClosed().subscribe(salvou=>{if(salvou)this.atualizarDados(true);});
  }

  atualizando = false;
  atualizarDados(repassesSalvos = false): void {
    if (this.atualizando) return;
    this.atualizando = true;
    this.deducoesService.atualizar(this.beneficiario.matricula, this.beneficiario.orgao.id).subscribe({
      next: dados => {
        this.deducoes = dados; this.atualizando = false;
        this.snackBar.open('Dados atualizados e salvos.', 'Fechar', {duration: 3000});

      },
      error: err => {
        this.atualizando = false;
        this.snackBar.open(repassesSalvos ? 'Repasses salvos. Não foi possível atualizar os tempos; tente Atualizar e Salvar Dados.' : (err.error?.message ?? err.error?.detail ?? 'Não foi possível atualizar os dados.'), 'Fechar', {duration: 5000});
      }
    });
  }

  ngOnInit(): void {
    this.beneficiario = this.sessionService.beneficiario;

    this.deducoesService
      .getDeducoes(this.beneficiario.matricula, this.beneficiario.orgao.id)
      .subscribe({
        next: (res: any) => {
          this.loading = false;
          this.deducoes = res;
        },
        error: (err: any) => {
          this.loading = false;
          console.error('Erro ao buscar deduções', err);
        },
      });
  }

  // === Upload / Download / Delete ===

  abrirModalUpload(deducao: any): void {
    this.deducaoSelecionada = deducao;
    this.selectedFile = null;
    this.uploading = false;

    this.dialogRef = this.dialog.open(this.modalUpload, {
      data: deducao,
      width: '600px',
      maxWidth: '95vw',
    });
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.selectedFile =
      input.files && input.files.length ? input.files[0] : null;
  }

  private getIdOrigemFromDeducao(d: any): number {
    // Usamos idAfastamento como prioridade (dedução por afastamento), depois id, depois provimentoId (fallback)
    return d?.idAfastamento;
  }

  enviarDocumento(): void {
    if (!this.selectedFile || !this.deducaoSelecionada) return;

    const idOrigem = this.getIdOrigemFromDeducao(this.deducaoSelecionada);
    if (!idOrigem) {
      this.snackBar.open(
        'Não foi possível identificar o id de origem da dedução.',
        'Fechar',
        {
          duration: 3000,
          horizontalPosition: 'right',
          verticalPosition: 'bottom',
        }
      );
      return;
    }

    this.uploading = true;
    this.deducoesService
      .uploadDeducaoDocumento(idOrigem, this.selectedFile, this.deducaoSelecionada.motivoAfastamento)
      .subscribe({
        next: (res: any) => {
          this.uploading = false;
          if (/^(erro|falha|não foi possível)/i.test(res?.message?.trim() ?? '')) {
            this.snackBar.open(res.message, 'Fechar', {duration: 5000});
            return;
          }
          this.snackBar.open('Documento enviado com sucesso ✅', 'Fechar', {
            duration: 3000,
            horizontalPosition: 'right',
            verticalPosition: 'bottom',
          });
          this.dialogRef?.close();
          this.deducoesService
            .getDeducoes(
              this.beneficiario.matricula,
              this.beneficiario.orgao.id
            )
            .subscribe({
              next: (res: any) => {
                this.loading = false;
                this.deducoes = res;
              },
              error: (err: any) => {
                this.loading = false;
                console.error('Erro ao buscar deduções', err);
              },
            });
        },
        error: (err) => {
          this.uploading = false;
          console.error('Erro ao enviar documento', err);
          this.snackBar.open('Falha ao enviar documento ❌', 'Fechar', {
            duration: 4000,
            horizontalPosition: 'right',
            verticalPosition: 'bottom',
          });
        },
      });
  }

  downloadFile(deducao: any): void {
    const hash = deducao?.hashDoc || deducao?.hash;
    if (!hash) {
      this.snackBar.open(
        'Nenhum documento anexado para esta dedução.',
        'Fechar',
        {
          duration: 3000,
          horizontalPosition: 'right',
          verticalPosition: 'bottom',
        }
      );
      return;
    }

    this.deducoesService.downloadDocumentoPorHash(hash).subscribe({
      next: (res) => {
        const blob = res.body as Blob;
        const cd =
          res.headers.get('Content-Disposition') ||
          res.headers.get('content-disposition') ||
          '';
        const match = /filename\*?=(?:UTF-8''|")?([^\";]+)/i.exec(cd);
        const filenameFromHeader = match ? decodeURIComponent(match[1]) : null;
        const fallback = `deducao_${
          deducao.id ?? deducao.idAfastamento ?? 'documento'
        }.pdf`;
        const filename = filenameFromHeader || fallback;

        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      },
      error: (err) => {
        console.error('Erro ao baixar documento', err);
        this.snackBar.open('Falha ao baixar documento.', 'Fechar', {
          duration: 3000,
          horizontalPosition: 'right',
          verticalPosition: 'bottom',
        });
      },
    });
  }

  deletarDocumento(deducao: any): void {
    const hash = deducao?.hashDoc || deducao?.hash;
    if (!hash) {
      this.snackBar.open(
        'Nenhum documento para excluir nesta dedução.',
        'Fechar',
        {
          duration: 3000,
          horizontalPosition: 'right',
          verticalPosition: 'bottom',
        }
      );

      return;
    }

    this.deducoesService.deleteDocumentoPorHash(hash).subscribe({
      next: () => {
        this.snackBar.open('Documento excluído com sucesso ✅', 'Fechar', {
          duration: 3000,
          horizontalPosition: 'right',
          verticalPosition: 'bottom',
        });
        deducao.hashDoc = null;
        this.deducoesService
          .getDeducoes(this.beneficiario.matricula, this.beneficiario.orgao.id)
          .subscribe({
            next: (res: any) => {
              this.loading = false;
              this.deducoes = res;
            },
            error: (err: any) => {
              this.loading = false;
              console.error('Erro ao buscar deduções', err);
            },
          });
        if ('hash' in deducao) deducao.hash = null;
      },
      error: (err) => {
        console.error('Erro ao excluir documento', err);
        this.deducoesService
          .getDeducoes(this.beneficiario.matricula, this.beneficiario.orgao.id)
          .subscribe({
            next: (res: any) => {
              this.loading = false;
              this.deducoes = res;
            },
            error: (err: any) => {
              this.loading = false;
              console.error('Erro ao buscar deduções', err);
            },
          });
        this.snackBar.open('Não foi possível excluir o documento. Tente novamente.', 'Fechar', {
          duration: 3000,
          horizontalPosition: 'right',
          verticalPosition: 'bottom',
        });
      },
    });
  }

}
